import {LeaderboardUser} from '@dms/api/settings';

import {isHiddenOperation} from './isHiddenOperation';

/**
 * A user's `total` with their hidden operations' counts subtracted out, so the
 * leaderboard Total column, Sum/Avg/Min/Max stats, default sort, and Total row
 * all reflect only visible operations.
 */
export const getVisibleUserTotal = (user: LeaderboardUser): number =>
  user.byOperationType
    .filter(isHiddenOperation)
    .reduce((total, operation) => total - operation.count, user.total);
